import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/products/pipe.png'
import _imports_1 from '@/assets/image/products/road-construction.png'
import _imports_2 from '@/assets/image/products/water-proof.png'
import _imports_3 from '@/assets/image/products/bridge.png'
import _imports_4 from '@/assets/image/products/drainage-cell.png'
import _imports_5 from '@/assets/image/products/cover-plastic.png'


const _hoisted_1 = { id: "products" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "PRODUCTS"),
  /*#__PURE__*/_createElementVNode("h1", null, "Explore Product Features")
], -1)
const _hoisted_3 = { class: "product-box" }
const _hoisted_4 = { class: "single-product" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "soil-layer"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_7 = { class: "product-desc" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Geotextiles", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "งานปรับภูมิทัศน์, หุ้มท่อน้ำฝังดิน", -1)
const _hoisted_11 = { class: "single-product" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "soil-layer"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_14 = { class: "product-desc" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Geotextiles", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "งานถนน, ลานจอดรถ, สนามบิน, ทางรถไฟ", -1)
const _hoisted_18 = { class: "single-product" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "soil-layer"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_21 = { class: "product-desc" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", null, "Geotextiles", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "งานกันซึม", -1)
const _hoisted_25 = { class: "single-product" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Bridge"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_28 = { class: "product-desc" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", null, "Geotextiles", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "งานกำแพงกันดิน, สันเขื่อน, คอสะพาน", -1)
const _hoisted_32 = { class: "single-product" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "drainage-cell"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_35 = { class: "product-desc" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", null, "Drainage Cell", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "ตะแกรงระบายน้ำ", -1)
const _hoisted_39 = { class: "single-product" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "cover-plastic"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_42 = { class: "product-desc" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", null, "Cover Plastic", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "พลาสติกรองเทคอนกรีต, บ่อน้ำ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createVNode(_component_RouterLink, {
            to: "/product-1",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _createVNode(_component_RouterLink, {
            to: "/product-2",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _createVNode(_component_RouterLink, {
            to: "/product-3",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _hoisted_30,
          _hoisted_31,
          _createVNode(_component_RouterLink, {
            to: "/product-4",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _hoisted_37,
          _hoisted_38,
          _createVNode(_component_RouterLink, {
            to: "/product-5",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _hoisted_44,
          _hoisted_45,
          _createVNode(_component_RouterLink, {
            to: "/product-6",
            class: "router-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn More")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}